(function (f) {
    'use strict';

    'function' === typeof define && define.amd ? define(['exports'], f) : 'undefined' !== typeof module && module.exports ? module.exports = f() : f();

})(function () {

    // UTILS
    const root = {};

    function getDataAttr(elem, name) {
        const value = elem.dataset[name];
        const num = parseFloat(value);
        return !isNaN(num) ? num : value;
    }

    function setDataAttr(elem, name, value) {
        elem.dataset[name] = value;
    }

    root.setData = (elem, name, value, write) => {
        elem.data = elem.data || {};
        if (typeof value === 'undefined') {
            delete elem.data[name];
            if (write)
                setDataAttr(elem, name, '');
            return value;
        }
        elem.data[name] = value;
        if (write)
            setDataAttr(elem, name, value);
        return value;
    }

    root.getData = (elem, name) => {
        elem.data = elem.data || {};
        if (typeof elem.data[name] === 'undefined')
            root.setData(elem, name, getDataAttr(elem, name));
        return elem.data[name];
    }

    return root;

});


// WEBPACK FOOTER //
// ./js/viscom/viscomjs/utils/data.js